import React, { useRef, useEffect } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import useFigure from "../../hooks/useFigure";
import { Wrapper } from "./styles";

const ThreeFigure = ({ figureData }) => {
  const defaultFigure = figureData || {
    name: "cylinder",
    values: {
      height: 0.4,
      width: 2
    }
  };

  const mount = useRef(null);
  const { figure } = useFigure(defaultFigure);

  useEffect(() => {
    let mountCopy = mount;
    if (figure) {
      let width = mountCopy.current.clientWidth;
      let height = mountCopy.current.clientHeight;
      let frameId;

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });

      scene.add(figure);

      const lights = [];
      lights[0] = new THREE.PointLight(0xffffff, 1, 0);
      lights[1] = new THREE.PointLight(0xffffff, 1, 0);
      lights[2] = new THREE.PointLight(0xffffff, 1, 0);

      lights[0].position.set(0, 20, 0);
      lights[1].position.set(20, 0, 0);
      lights[2].position.set(0, 0, 20);

      scene.add(lights[0]);
      scene.add(lights[2]);

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.2);
      scene.add(ambientLight);

      camera.position.z = 4;

      const orbitControl = new OrbitControls(camera, renderer.domElement);
      orbitControl.update();

      renderer.setClearColor(0x000000, 0);
      renderer.setSize(width, height);

      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.BasicShadowMap;

      const renderScene = () => {
        renderer.render(scene, camera);
      };

      const handleResize = () => {
        width = mountCopy.current.clientWidth;
        height = mountCopy.current.clientHeight;
        renderer.setSize(width, height);
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderScene();
      };

      const animate = () => {
        orbitControl.update();
        renderScene();
        frameId = window.requestAnimationFrame(animate);
      };

      const start = () => {
        if (!frameId) {
          frameId = requestAnimationFrame(animate);
        }
      };

      const stop = () => {
        cancelAnimationFrame(frameId);
        frameId = null;
      };

      mountCopy.current.appendChild(renderer.domElement);
      window.addEventListener("resize", handleResize);
      start();

      return () => {
        stop();
        window.removeEventListener("resize", handleResize);
        mountCopy.current.removeChild(renderer.domElement);

        scene.remove(figure);
      };
    }
  }, [figure]);

  return (
    <Wrapper
      ref={mount}
    />
  );
};

export default ThreeFigure;
